module.exports = __webpack_public_path__ + "static/grey-background-9897e5e54da91438ee0b8148299ba782.png";